import React, { useState } from "react";
import api from "../../api/axios";

interface Props {
  data: any;
  setData: (d: any) => void;
  onSave: () => void;
  onDelete: () => void;
}

const inputSt: React.CSSProperties = {
  flex: 1, padding: "7px 10px", borderRadius: 7,
  border: "1px solid #374151", background: "#1a2030",
  color: "#f9fafb", fontSize: 13, outline: "none",
  width: "100%", boxSizing: "border-box" as const,
};

export default function IntegrationCard({ data, setData, onSave, onDelete }: Props) {
  const [testPhone, setTestPhone] = useState("");
  const [testLoading, setTestLoading] = useState(false);
  const [testResult, setTestResult] = useState<string | null>(null);

  const handleTestSms = async () => {
    if (!testPhone) return;
    setTestLoading(true);
    setTestResult(null);
    try {
      await api.post('/sms/test', { phone: testPhone });
      setTestResult('✓ SMS отправлено успешно');
    } catch (e: any) {
      setTestResult(`✗ ${e?.response?.data?.message || 'Ошибка отправки'}`);
    } finally {
      setTestLoading(false);
    }
  };

  const deleteField = (key: string) => {
    const newConfig = { ...data.config };
    const newTypes = { ...data.fieldTypes };
    delete newConfig[key];
    delete newTypes[key];
    setData({ ...data, config: newConfig, fieldTypes: newTypes });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#f9fafb" }}>
          {data.displayName || data.name}
        </h2>

        <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
          <span style={{ fontSize: 12, color: "#6b7280", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            Включена
          </span>
          <input
            type="checkbox"
            checked={data.enabled}
            onChange={(e) => setData({ ...data, enabled: e.target.checked })}
            style={{ width: 16, height: 16, accentColor: "#6366f1", cursor: "pointer" }}
          />
        </label>
      </div>

      {/* Fields */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: "0.07em", color: "#6b7280", marginBottom: 2 }}>
          Поля интеграции
        </div>

        {Object.entries(data.config).map(([key, value]) => {
          const type = data.fieldTypes[key] ?? "string";
          const isMob = window.innerWidth <= 768;
          return (
            <div key={key} style={{ display: "flex", flexDirection: isMob ? "column" : "row", alignItems: isMob ? "stretch" : "center", gap: isMob ? 4 : 8 }}>
              <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: "0.06em", color: "#6b7280", flexShrink: 0, width: isMob ? "auto" : 120 }}>
                {key}
              </span>

              {(type === "string" || type === "number") && (
                <input
                  type={type === "number" ? "number" : "text"}
                  value={String(value ?? "")}
                  onChange={(e) => setData({ ...data, config: { ...data.config, [key]: type === "number" ? Number(e.target.value) : e.target.value } })}
                  style={inputSt}
                />
              )}

              {type === "secret" && (
                <input
                  type="password"
                  value={String(value ?? "")}
                  onChange={(e) => setData({ ...data, config: { ...data.config, [key]: e.target.value } })}
                  style={inputSt}
                />
              )}

              {type === "textarea" && (
                <textarea
                  value={String(value ?? "")}
                  onChange={(e) => setData({ ...data, config: { ...data.config, [key]: e.target.value } })}
                  style={{ ...inputSt, minHeight: 70, resize: "vertical" as const }}
                />
              )}

              {type === "boolean" && (
                <input
                  type="checkbox"
                  checked={Boolean(value)}
                  onChange={(e) => setData({ ...data, config: { ...data.config, [key]: e.target.checked } })}
                  style={{ width: 16, height: 16, accentColor: "#6366f1" }}
                />
              )}

              <button
                onClick={() => deleteField(key)}
                style={{ background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: 6, color: "#ef4444", cursor: "pointer", fontSize: 12, padding: "4px 8px", flexShrink: 0 }}
              >
                ✕
              </button>
            </div>
          );
        })}
      </div>

      {/* Actions */}
      <div style={{ display: "flex", gap: 8, paddingTop: 4 }}>
        <button
          onClick={onSave}
          style={{ background: "#6366f1", color: "#fff", border: "none", borderRadius: 8, padding: "8px 20px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
        >
          Сохранить
        </button>
        <button
          onClick={onDelete}
          style={{ background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: 8, color: "#ef4444", cursor: "pointer", fontSize: 13, padding: "8px 16px" }}
        >
          Удалить интеграцию
        </button>
      </div>

      {/* Тест SMS — только для kazinfoteh_sms */}
      {data.name === 'kazinfoteh_sms' && (
        <div style={{ paddingTop: 8, borderTop: '1px solid #1f2937' }}>
          <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
            Тест отправки SMS
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input
              type="text"
              placeholder="+77001234567"
              value={testPhone}
              onChange={e => setTestPhone(e.target.value)}
              style={{ ...inputSt, maxWidth: 200 }}
            />
            <button
              onClick={handleTestSms}
              disabled={testLoading || !testPhone}
              style={{ background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: testLoading ? 0.7 : 1 }}
            >
              {testLoading ? 'Отправка...' : 'Отправить тест'}
            </button>
          </div>
          {testResult && (
            <p style={{ marginTop: 8, fontSize: 13, color: testResult.startsWith('✓') ? '#4ade80' : '#ef4444' }}>
              {testResult}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
